/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.enterAnimation = function () {
    let $loader = $('.c-loader');
    if (!$loader.length === 0) {
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      // ここから実行
      if ($loader) {
        changeClass($loader, "is-active", 1000).then(function () {
          changeClass($loader, "is-close", 2000).then(function () {
            changeClass($loader, "is-hidden", 1000).then(function () {

            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      // テストはこちらをコメントアウト外す
      // loaderFunction();
      $loader.addClass('is-already');
    }
  };

  growApp.prototype.backCache = function () {
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    }
  }

  growApp.prototype.accordionAllButton = function () {
    const AllButton = $(".js-all-show");
    const targetBlock = $(".c-accordion__block");
    const targetContent = $(".c-accordion__content");

    AllButton.click(function (e) {
      e.preventDefault();

      let isOpen = false;
      if (AllButton.hasClass('is-active')) {
        isOpen = true;
      }

      AllButton.toggleClass('is-active');

      if (isOpen) {
        targetBlock.removeClass("is-open");
        targetContent.hide();
      } else {
        targetBlock.addClass("is-open");
        targetContent.show();
      }

      // AllButton.toggleClass('is-active');
      // for (let i = 0; i < targetBlock.length; i++) {
      //     targetBlock.eq(i).toggleClass("is-open");
      //     targetContent.eq(i).toggle();
      // }
    });
  }

  growApp.prototype.popUp = function () {
    let $target = $('.js-pop-up');
    let $trigger = $('.c-pop-up');
    let $overlay = $('.c-pop-up__overlay');
    let $close = $('.c-pop-up__close');

    if (!$target) {
      return false;
    }

    $target.on('click', function () {
      $(this).children($trigger).addClass('is-open');
    });

    $overlay.on('click', function () {
      $(this).parent().removeClass('is-open');
      return false;
    });
    $close.on('click', function () {
      $(this).parent().parent().removeClass('is-open');
      return false;
    });
  }

  growApp.prototype.queryLink = function () {
    let param = location.search;
    let $tab = $('.js-tabs-nav li a');
    let $content = $('.c-tabs__content');

    if (param == "") {
      return false;
    }

    $tab.removeClass('is-active');
    $content.removeClass('is-active');

    if (param == "?content1") {
      $tab.eq(0).addClass('is-active');
      $content.eq(0).addClass('is-active');

    } else if (param == "?content2") {
      $tab.eq(1).addClass('is-active');
      $content.eq(1).addClass('is-active');
    }
  }

  growApp.prototype.removeSlidebar = function () {
    let $target = $('.js-remove-slidebar');

    $target.on('click', function () {
      $("body").removeClass("is-slidebar-active");
    });
  }

  growApp.prototype.modalContents = function () {
    $('.js-modal-content').modaal({
      before_open: function () {
        $('body').addClass('is-modaal-open');
      },
      after_close: function () {
        $('body').removeClass('is-modaal-open');
      },
      overlay_opacity: 0.6,
      padding: 30
    });

  }

  // growApp.prototype.modalWindow = function () {
  //   $(".js-modal.foreigner").modaal({
  //     content_source: '#modal-foreigner',
  //     width: 944
  //   });
  // }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.enterAnimation();
    app.accordionAllButton();
    app.popUp();
    app.queryLink();
    app.removeSlidebar();
    app.modalContents();
    // app.modalWindow();
  });
})(jQuery);
